// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions__mu4Gs","action":"styles_action__1ijwj"};